// Notification bell + dropdown. Polls the feed, shows an unread badge, marks read on open, and
// deep-links to the related order on click.
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BellIcon } from '../icons.jsx';
import { fetchNotifications, markNotificationsRead } from '../../api/notifications.js';

export default function NotificationsBell() {
  const navigate = useNavigate();
  const [data, setData] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const load = () => fetchNotifications().then(setData).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next && data.unread) {
      await markNotificationsRead().catch(() => {});
      setData((d) => ({ ...d, unread: 0, items: d.items.map((i) => ({ ...i, isRead: true })) }));
    }
  };
  const go = (n) => {
    setOpen(false);
    if (n.link) navigate(n.link);
  };

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        aria-label="Notifications"
        onClick={toggle}
        className="relative flex h-9 w-9 items-center justify-center rounded-md text-text-muted transition hover:bg-surface-raised hover:text-text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40"
      >
        <BellIcon size={18} />
        {data.unread > 0 && (
          <span className="absolute right-0.5 top-0.5 flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-error px-1 text-[10px] font-semibold text-white">
            {data.unread > 9 ? '9+' : data.unread}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 top-full z-30 mt-1 max-h-96 w-80 overflow-auto rounded-md border border-line bg-surface p-1 shadow-lg">
          <div className="px-3 py-2 text-xs font-semibold text-text-muted">Notifications</div>
          {data.items.length === 0 ? (
            <div className="px-3 py-6 text-center text-xs text-text-muted">You’re all caught up.</div>
          ) : (
            data.items.map((n) => (
              <button
                key={n.id}
                onClick={() => go(n)}
                className={`block w-full rounded px-3 py-2 text-left text-sm transition hover:bg-surface-raised ${n.isRead ? 'text-text-secondary' : 'text-text-primary'}`}
              >
                <div className="flex items-start gap-2">
                  {!n.isRead && <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-accent" />}
                  <div className="min-w-0">
                    <div>{n.message}</div>
                    <div className="mt-0.5 text-[11px] text-text-muted">{new Date(n.createdAt).toLocaleString()}</div>
                  </div>
                </div>
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
}
